/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @param {string} drawerClass - Optional class to add based on drawer type
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(drawerClass = null){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    
    // Add drawer-specific class if provided
    if (drawerClass) {
      Utility.CSS.add(overlay, drawerClass);
    }
    
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    // Remove all drawer-specific overlay classes (keep only overlay--body and scroll-fixed)
    const overlayClasses = Array.from(overlay.classList).filter(cls => cls !== 'overlay--body' && cls !== 'scroll-fixed');
    overlayClasses.forEach(cls => Utility.CSS.remove(overlay, cls));
    
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
if (!customElements.get('site-overlay')) {
  customElements.define("site-overlay", SiteOverlay);
}

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.videoType;
    this.videoURL = this.dataset.videoId;
    this.placementType = this.dataset.placement;
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = Utility.DomSelector.$('.content-section', this);
    this.videoSection = Utility.DomSelector.$('.video-section', this);
    if(this.placementType == 'popup') this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
    this.triggerVideo = Utility.DomSelector.$('[data-trigger-video]', this) || Utility.DomSelector.$('[data-trigger-video]', this.container);
    this.muteToggle = null;

    this.boundToggleView = this.toggleView.bind(this);
    this.boundToggleMute = this.toggleMute.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo && this.boundToggleView) {
      this.triggerVideo.removeEventListener('click', this.boundToggleView);
    }
    if (this.muteToggle && this.boundToggleMute) {
      this.muteToggle.removeEventListener('click', this.boundToggleMute);
    }
    this.scrollObserver?.disconnect();
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(Utility.DomSelector.exists('[data-poster-video]', this)) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.boundToggleView);

    this.muteToggle = Utility.DomSelector.$('[data-video-mute-toggle]', this);
    if(this.muteToggle) {
      this.syncMuteUI();
      this.muteToggle.addEventListener('click', this.boundToggleMute);
    }

    // Autoplay on init if placement is grid and autoplay is true and not in a swiper slide. Slider autoplay is managed by the manageSwiperSlides function to support slide init with deferred js loading.
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Toggle mute/unmute on the playing video
   */
  toggleMute(event){
    if(event){
      event.preventDefault();
      event.stopPropagation();
    }

    const nextMuted = this.dataset.muted !== 'true';
    this.dataset.muted = String(nextMuted);

    const video = Utility.DomSelector.$('.video-section video', this);
    if(video) video.muted = nextMuted;

    if(this.type === 'youtube'){
      const iframe = Utility.DomSelector.$('.video-section iframe', this);
      iframe?.contentWindow?.postMessage(
        `{"event":"command","func":"${nextMuted ? 'mute' : 'unMute'}","args":""}`,
        'https://www.youtube.com'
      );
    }

    this.syncMuteUI();
  }

  /**
   * Sync mute button icon + aria-label with current muted state
   */
  syncMuteUI(){
    if(!this.muteToggle) return;

    const isMuted = this.dataset.muted === 'true';
    this.muteToggle.classList.toggle('is-muted', isMuted);
    this.muteToggle.setAttribute(
      'aria-label',
      isMuted
        ? (this.muteToggle.dataset.ariaMuted || 'Unmute video')
        : (this.muteToggle.dataset.ariaUnmuted || 'Mute video')
    );
  }

  /**
   * Pause/stop other playing custom videos
   */
  pauseOtherVideos(){
    Utility.DomSelector.$$('custom-video').forEach((videoHost) => {
      if(videoHost === this) return;
      const container = videoHost.closest('.custom-video-container');
      if(container?.classList.contains('playing--video') && typeof videoHost.hideContent === 'function'){
        videoHost.hideContent();
      }
    });
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   * @returns {CustomVideo} Returns this for method chaining
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
    return this; // Enable method chaining
  }

  /**
   * Show panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  showContent() {
    this.pauseOtherVideos();

    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      if (!videoElement) {
        console.error('Failed to build video element');
        return this;
      }
      
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      
      if (!this.videoSection) {
        console.error('Video section not found');
        return this;
      }
      
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : Utility.CSS.add(this.container, 'playing--video');
        this.videoSection.removeAttribute('inert');
        this.videoSection.setAttribute('aria-hidden', 'false');
        this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
      if (videoElement) {
        Utility.CSS.add(this.container, 'playing--video');
        this._playVideo(videoElement);
        this.pauseOnVisibilityChange(videoElement);
      }
    }
    return this; // Enable method chaining
  }

  /**
   * Hide panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  hideContent() {
    this.scrollObserver?.disconnect();
    this.scrollObserver = null;
    Utility.CSS.remove(this.container, 'playing--video');
    this.videoSection.setAttribute('inert', '');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
    return this; // Enable method chaining
  }

  _playVideo(video){
    if (!video) return;

    try {
      if(this.type === 'local'){
        video.play().catch(err => console.warn('Video autoplay blocked:', err));
      } else if(this.type === 'youtube'){
        video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Play video error:', err);
    }
  }

  _pauseVideo(video) {
    if (!video) return;
    
    try {
      if (this.type === 'local') {
        video.pause();
      } else if (this.type === 'youtube') {
        video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Pause video error:', err);
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    try {
      if (!this.videoURL) {
        console.error('Video URL is missing');
        return null;
      }

      const hasControls = this.dataset.controls === 'true';
      const isMuted = this.dataset.muted === 'true';
      const isLoop = this.dataset.loop === 'true';

      if(this.type === 'local'){
        const video = document.createElement('video');
        video.src = this.videoURL;
        video.autoplay = true;
        video.playsInline = true;
        if(hasControls) video.controls = true;
        if(isMuted) video.muted = true;
        if(isLoop) video.loop = true;
        return video;
      }

      if(this.type === 'youtube'){
        const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
        if (!videoID) {
          console.error('Invalid YouTube URL');
          return null;
        }
        const video = document.createElement("iframe");
        video.setAttribute("allowfullscreen", "");
        video.setAttribute("frameborder", "0");
        video.setAttribute("allow", "autoplay");
        video.setAttribute("src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${isMuted ? 1 : 0}&controls=${hasControls ? 1 : 0}&loop=${isLoop ? 1 : 0}&enablejsapi=1&origin=${window.origin}`);
        return video;
      }

      return null;
    } catch (err) {
      console.error('Video build error:', err);
      return null;
    }
  }

  /**
   * Stop video when it leaves the viewport
   */
  pauseOnVisibilityChange(_videoEle){
    this.scrollObserver?.disconnect();

    this.scrollObserver = Utility.Observer.onChange(
      this,
      null,
      () => {
        if(this.container?.classList.contains('playing--video')){
          this.hideContent();
        }
      }
    );
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = Utility.DomSelector.$('[data-poster-video]', this);
    if(!posterVideo) return;

    const attachAndPlay = (video) => {
      try {
        if (!video.getAttribute('src') && !video.querySelector('source')) {
          if (!video.dataset.src) return;
          const sourceTag = document.createElement('source');
          sourceTag.src = video.dataset.src;
          sourceTag.type = "video/mp4";
          video.appendChild(sourceTag);
        }
        video.play().catch(err => console.warn('Poster video autoplay blocked:', err));
      } catch (err) {
        console.error('Poster video error:', err);
      }
    };

    if (posterVideo.getAttribute('src')) {
      attachAndPlay(posterVideo);
      return;
    }

    Utility.Observer.once(posterVideo, attachAndPlay);
  }

  autoplayOnInit(element = this){
    Utility.Observer.once(element, (el, entry) => {
      if(entry.intersectionRatio > 0){
        el.toggleView();
      }
    });
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn); // falls back to first focusable element if no close button

    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      Utility.DomSelector.$('.video-container', this).innerHTML = '';
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = Utility.DomSelector.$$('[data-closedrawer]', this);
      const focusSelector = this.dataset.focusSelector;
      this.forceFocus = focusSelector
        ? Utility.DomSelector.$(focusSelector, this)
        : Utility.DomSelector.$('[data-closedrawer]', this);
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  get usesSiteOverlay() {
    return this.dataset.siteOverlay !== 'false';
  }

  updateTriggerParentState(isOpen) {
    if (this.id !== 'header-search-layer') return;

    const triggerParent = this.openedBy?.closest('li');
    if (!triggerParent) return;

    if (isOpen) {
      Utility.CSS.add(triggerParent, 'open');
    } else {
      Utility.CSS.remove(triggerParent, 'open');
    }
  }

  openDrawer(opener) {
    // Prevent opening if already open
    if (this.isOpen) return this;

    // Cancel a pending quickshop body clear if reopening during close animation
    if (this.id === 'quickshop-drawer') {
      if (this._quickshopClearTimer) {
        clearTimeout(this._quickshopClearTimer);
        this._quickshopClearTimer = null;
      }
      if (this._quickshopClearOnEnd) {
        this.removeEventListener('transitionend', this._quickshopClearOnEnd);
        this._quickshopClearOnEnd = null;
      }
    }

    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    if (this.usesSiteOverlay) {
      // Create drawer-specific overlay class from drawer ID
      const drawerClass = this.id || null;
      SiteOverlay.showOverlay(drawerClass);

      // Add below-header class to overlay if drawer has it
      const overlay = Utility.DomSelector.byId('site-overlay');
      if (overlay && this.classList.contains('below-header')) {
        Utility.CSS.add(overlay, 'below-header');
      }
    }
    
    this.openedBy?.setAttribute('aria-expanded', true);
    this.updateTriggerParentState(true);
    Utility.Focus.trap(this, this.forceFocus); // falls back to first focusable element if no close button

    // Cart drawer: wallets often init while collapsed — activate scripts + re-init when opened
    if (this.id === 'component-cart-drawer') {
      document.querySelectorAll('script[data-src*="portable-wallets"]').forEach((script) => {
        const src = script.dataset.src;
        if (!src || script.src) return;
        script.src = src;
        script.removeAttribute('data-src');
        script.setAttribute('data-loaded', 'true');
      });
      if (typeof CollapsiblePanel !== 'undefined' && typeof CollapsiblePanel.init === 'function') {
        CollapsiblePanel.init();
      }
      globalThis?.Shopify?.Checkout?.configureExpressCheckout?.();
      globalThis?.Shopify?.PaymentButton?.init();

      // Touch/Safari: auto-open more-payments so wallets mount while visible
      const isTouch = (navigator.maxTouchPoints > 0) || window.matchMedia('(pointer: coarse)').matches;
      if (isTouch) {
        const morePayments = this.querySelector('[data-more-payments]');
        const instance = morePayments?._collapsiblePanelInstance;
        if (instance && !morePayments.classList.contains('open')) {
          requestAnimationFrame(() => {
            instance.showContent();
            setTimeout(() => {
              globalThis?.Shopify?.Checkout?.configureExpressCheckout?.();
              globalThis?.Shopify?.PaymentButton?.init();
            }, 150);
          });
        }
      }
    }

    // Announce drawer opening to screen readers
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);
    
    return this; // Enable method chaining
  }

  closeDrawer() {
      if (!this.isOpen) return this;

      Utility.CSS.remove(this, 'open');

      if (this.usesSiteOverlay) {
        // Remove drawer-specific overlay class and below-header class
        const overlay = Utility.DomSelector.byId('site-overlay');
        if (overlay && this.id) {
          Utility.CSS.remove(overlay, this.id);
          Utility.CSS.remove(overlay, 'below-header');
        }

        SiteOverlay.hideOverlay();
      }

      this.isOpen = false;
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.hideOpenPanels();
      this.openedBy?.setAttribute('aria-expanded', false);
      this.updateTriggerParentState(false);
      Utility.Focus.release(this.openedBy);
      
      // Announce drawer closing to screen readers
      const drawerName = this.getAttribute('aria-label') || 'Drawer';
      Utility.announceToScreenReader(`${drawerName} drawer closed`);
      
      if(this.id == 'quickshop-drawer') {
        this.clearQuickshopBodyAfterTransition();
      }else if(this.id == 'header-search-layer') {
        const searchInput = this.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
        }
      }
      this.openedBy = null;
      
      return this; // Enable method chaining
  }

  /**
   * Clears quickshop HTML after the slide-out transition so desktop
   * (transparent drawer shell) still animates like mobile.
   */
  clearQuickshopBodyAfterTransition() {
    const body = Utility.DomSelector.$('[data-quickshop-body]', this);
    if (!body) return;

    // Cancel any pending clear from a previous close
    if (this._quickshopClearTimer) {
      clearTimeout(this._quickshopClearTimer);
      this._quickshopClearTimer = null;
    }
    if (this._quickshopClearOnEnd) {
      this.removeEventListener('transitionend', this._quickshopClearOnEnd);
      this._quickshopClearOnEnd = null;
    }

    const clearBody = () => {
      if (this.classList.contains('open')) return;
      body.innerHTML = '';
    };

    this._quickshopClearOnEnd = (evt) => {
      if (evt.target !== this) return;
      if (evt.propertyName && evt.propertyName !== 'transform') return;
      this.removeEventListener('transitionend', this._quickshopClearOnEnd);
      this._quickshopClearOnEnd = null;
      if (this._quickshopClearTimer) {
        clearTimeout(this._quickshopClearTimer);
        this._quickshopClearTimer = null;
      }
      clearBody();
    };

    this.addEventListener('transitionend', this._quickshopClearOnEnd);
    // Fallback if transitionend does not fire (reduced motion / interrupted)
    this._quickshopClearTimer = setTimeout(() => {
      this.removeEventListener('transitionend', this._quickshopClearOnEnd);
      this._quickshopClearOnEnd = null;
      this._quickshopClearTimer = null;
      clearBody();
    }, 350);
  }

  resetOtherDrawers(){
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    return this; // Enable method chaining
  }

  hideOpenPanels(){
    const openPanels = this.querySelectorAll('[is="collapsiblePanel"].open, [is="collapsiblePanel"] .toggle-content.open');
    openPanels.forEach((el) => {
      const panel = el.matches?.('[is="collapsiblePanel"]') ? el : el.closest('[is="collapsiblePanel"]');
      if (!panel) return;
      if (panel._collapsiblePanelInstance) {
        panel._collapsiblePanelInstance.hideContent({ restoreFocus: false });
      } else {
        Utility.toggleElement(panel, 'close');
        panel.querySelector('[data-toggle="panel"]')?.setAttribute('aria-expanded', 'false');
      }
    });

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      Utility.CSS.remove(ele, 'open');
      Utility.DomSelector.$('[data-toggle="open"]', ele)?.setAttribute('aria-expanded', false);
    });
    return this; // Enable method chaining
  }
}
customElements.define('custom-drawer', CustomDrawer);

(() => {
  const handleOutsideDrawerClick = (event) => {
    Utility.DomSelector.$$('custom-drawer[data-close-on-outside="true"].open').forEach((drawer) => {
      if (drawer.contains(event.target)) return;

      const triggers = Utility.DomSelector.$$(`[data-toggleDrawer="${drawer.id}"], a[href="#${drawer.id}"]`);
      const clickedTrigger = triggers.some((trigger) => trigger === event.target || trigger.contains(event.target));
      if (clickedTrigger) return;

      drawer.closeDrawer();
    });
  };

  document.body.addEventListener('click', handleOutsideDrawerClick);
  document.body.addEventListener('touchstart', handleOutsideDrawerClick, { passive: true });
})();

// Single global Escape handler for all drawers, modals and dropdowns
document.addEventListener('keyup', (evt) => {
  if (!evt.code || evt.code.toUpperCase() !== 'ESCAPE') return;
  Utility.DomSelector.$$('custom-drawer.open').forEach(drawer => drawer.closeDrawer());
  Utility.DomSelector.$$('modal-dialog[aria-hidden="false"]').forEach(modal => modal.hide());
  Utility.DomSelector.$$('custom-select.open').forEach(select => select.closeDropdown());
});

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = Utility.DomSelector.$('.snotifyToast', this);
    this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   * @returns {ToastNotification} Returns this for method chaining
   */
  updateNotification(title, body, options){
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    Utility.CSS.add(this.container, 'open', `snotify-${options.type}`);
    Utility.DomSelector.$('.snotifyToast__title', this).textContent = title;
    Utility.DomSelector.$('.snotifyToast__body', this).textContent = body;

    this._manageToggle(options.timeout);
    
    return this; // Enable method chaining
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  /**
   * Hide notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    this.container.className = 'snotifyToast';
    [Utility.DomSelector.$('.snotifyToast__title', this),Utility.DomSelector.$('.snotifyToast__body', this)].forEach(ele => ele.textContent = '');
    Utility.DomSelector.$("[data-toast-pr]", this).removeAttribute("style");

    return this; // Enable method chaining
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = Utility.DomSelector.$('toast-notification');

//===============================================================================================================
//          Video Management Functions for Custom Video in Swiper Slides                                        //
//===============================================================================================================

/**
 * Handle slide video play/pause on slide change
 * @param {HTMLElement} slide 
 * @param {boolean} shouldPlay 
 */
const handleSlideVideo = (slide, shouldPlay) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (!videoHost) return;

  const media = Utility.DomSelector.$('video', videoHost) || Utility.DomSelector.$('iframe', videoHost);
  if (videoHost.videoStatus == 'loaded' && !media) return;

  try {
    if (shouldPlay) {
      if (videoHost.videoStatus === 'empty') {
        videoHost.toggleView();
      } else {
        videoHost._playVideo(media);
      }
    } else if (videoHost.dataset.controls === 'true') {
      videoHost._pauseVideo(media);
    }
  } catch (err) {
    console.error('Swiper slide video control error:', err);
  }
};

/**
 * Run autoplay on first active slide if autoplay is true and placement is grid
 * @param {HTMLElement} swiperEl 
 */
const runAutoplayIfActive = (swiperEl) => {
  if(!swiperEl || !swiperEl.querySelector('custom-video')) return;

  const firstActiveSlide = Utility.DomSelector.$('swiper-slide', swiperEl);
  if(!firstActiveSlide) return;

  const customVideo = firstActiveSlide.querySelector('custom-video');
  if(!customVideo) return;

  if(customVideo.dataset.autoplay === 'true' && customVideo.dataset.placement === 'grid') customVideo.autoplayOnInit(customVideo);
};

/**
 * Manage Swiper slide video control
 * @param {HTMLElement} swiperEl 
 */
const manageSwiperSlides = () => {
  const swiperSliders = Utility.DomSelector.$$('swiper-container');
  if(!swiperSliders.length) return;

  swiperSliders.forEach(swiperEl => {
    swiperEl.addEventListener('swiper:init', () => runAutoplayIfActive(swiperEl), { once: true });
    swiperEl.addEventListener('swiperslidechange', ({ detail }) => {
      const swiperInstance = detail && detail[0];
      if (!swiperInstance) return;

      const { activeIndex, previousIndex, slides } = swiperInstance;
      if (!slides || activeIndex == null || previousIndex == null) return;

      const prevSlide = slides[previousIndex];
      const activeSlide = slides[activeIndex];

      handleSlideVideo(prevSlide, false);
      handleSlideVideo(activeSlide, true);
    });
  });
};
manageSwiperSlides();

// Wait for Swiper JS to load
customElements.whenDefined('swiper-container')
  .then(() => {
    console.log('Swiper JS is loaded!');
})
  .catch((error) => {
    console.error('Swiper failed to load:', error);
});

//===============================================================================================================
//          End of Video Management Functions for Custom Video and Swiper Slide Components                      //
//===============================================================================================================


//===============================================================================================================
//          Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

(() => {
  const NAV_SELECTOR = '.custom-swiper-navigation';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;

  const updateHeights = () => {
    const cards = document.querySelectorAll('.card-product');
    if (cards.length === 0) return;

    // Batch read phase: collect all data
    // Reading offsetHeight forces layout, so we batch all reads together
    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const media = card.querySelector('.product--media');
      if (!media) continue;

      // Query nav in read phase (doesn't force layout, but batches DOM queries)
      const nav = card.closest('.swiper-wrapper__custom, section, .slider-wrapper')?.querySelector(`${NAV_SELECTOR}:not(.product-media-lightbox__nav)`);

      // Store all data for batch write phase
      updates.push({
        card,
        height: media.offsetHeight, // This forces layout - batched with all other reads
        nav
      });
    }

    // Batch write phase: apply all style changes at once
    // This reduces layout thrashing by grouping all writes together
    for (let i = 0; i < updates.length; i++) {
      const { card, height, nav } = updates[i];
      const heightStr = `${height}px`;

      // Apply card style
      card.style.setProperty('--product-media-height', heightStr);

      // Apply nav styles if nav exists (never on product media lightbox arrows)
      if (nav && !nav.classList.contains('product-media-lightbox__nav')) {
        nav.style.setProperty('--product-media-height', heightStr);
        nav.style.setProperty('--nav-opacity', '1');
        nav.classList.add('arrow-center-image');
      }
    }
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeights, { once: true });
  } else {
    updateHeights();
  }

  window.addEventListener('load', updateHeights);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });
})();

//===============================================================================================================
//          End of Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

// Dropdown outside-click handler → moved to dropdown.js

//===============================================================================================================
//          Header and Announcement Bar Height Calculator                                                       //
//===============================================================================================================


function setHeaderTopbarCSSVars() {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const topbar = document.querySelector('.topbar');
  const headerHeight = header ? header.offsetHeight : null;
  const topbarHeight = topbar ? topbar.offsetHeight : null;

  if (headerHeight != null) {
    root.style.setProperty('--header-height', headerHeight + 'px');
  }
  if (topbarHeight != null) {
    root.style.setProperty('--announcement-bar-height', topbarHeight + 'px');
  }
}
setHeaderTopbarCSSVars();
window.addEventListener('resize', setHeaderTopbarCSSVars);


//===============================================================================================================
//          End of Header and Announcement Bar Height Calculator                                               //
//===============================================================================================================

function setFeaturedCollectionProductCardHeight() {
  document.querySelectorAll('.featured-collection-products, .related-product-section').forEach(section => {
    const cards = section.querySelectorAll('.card-product');
    let maxHeight = 0;
    let maxButtonHeight = 0;

    cards.forEach(card => {
      const button = card.querySelector('.product_buy_buttons') || card.querySelector('.quickshop--button, .btn, .link-block');
      if (button) {
        const styles = getComputedStyle(button);
        const buttonHeight = button.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        if (buttonHeight > maxButtonHeight) maxButtonHeight = buttonHeight;
      }
    });

    if (maxButtonHeight > 0) {
      section.style.setProperty('--product-card-button-height', `${Math.round(maxButtonHeight)}px`);
    }

    cards.forEach(card => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > maxHeight) maxHeight = cardHeight;
    });
    if (maxHeight > 0) {
      section.style.setProperty('--product-card-height', `${maxHeight}px`);
    }
  });
}

// Run after DOM loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setFeaturedCollectionProductCardHeight);
} else {
  setFeaturedCollectionProductCardHeight();
}
// Also run after all images are loaded for accurate heights
window.addEventListener('load', setFeaturedCollectionProductCardHeight);

// Update on resize
let fcphResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(fcphResizeTimeout);
  fcphResizeTimeout = setTimeout(setFeaturedCollectionProductCardHeight, 150);
});


// // custom css for upcart cart drawer via JS
// const customJSSelectors = {};
// class customJS {
//   constructor() {
//     const styleTag = document.createElement("style");
//     styleTag.innerHTML = `
//       #UpcartPopup .upcart-internal-header.upcart-public-header {
//           background: #ffffff !important;
//           color: var(--pe-color-black) !important;
//           padding: 20px 15px !important;
//           border: none !important;
//       }
//       .upcart-internal-header span{
//         font-family: var(--pe-font-family-heading) !important;
//         font-size: var(--pe-h5-font-size-sm) !important;
//         font-weight: 300 !important;
//         line-height: 1.1 !important;
//         letter-spacing: 0.01em !important;
//       }
//       #UpcartPopup .upcart-internal-header__close-button {
//         background: transparent !important;
//       }
//       #UpcartPopup  .upcart-internal-header__close-button-icon {
//         fill: var(--pe-color-black) !important;
//         stroke: var(--pe-color-black) !important;
//       }
//       #UpcartPopup .upcart-cart-body {
//         padding: 0 20px 20px !important; 
//       }
//        #UpcartPopup .upcart-internal-rewards {
//         text-align: left !important;
//         border: 1px solid var(--pe-color-electric-blue) !important;
//         padding: 15px !important;
//         border-radius: 10px !important;
//       }
//       #UpcartPopup .upcart-internal-rewards__message[data-internal-properties*="isColumnReversed=false"] {
//         margin-bottom: 10px !important;
//         font-weight: 500 !important;
//             text-transform: capitalize;

//       }
//       #UpcartPopup .upcart-internal-component-segmented-progress-bar__segment {
//         background: var(--pe-color-light-gray) !important;
//       }
//       #UpcartPopup .upcart-internal-component-segmented-progress-bar__segment-fill {
//         background: var(--pe-color-electric-blue) !important;
//       }
//       #UpcartPopup .upcart-internal-cart-items, #UpcartPopup .upcart-internal-component-product-tile {
//         padding: 0 !important;
//         margin: 0 !important;
//         border: none !important;
//       }
//       #UpcartPopup .upcart-internal-cart-items .upcart-internal-cart-item{
//         padding-block: 20px !important;
//         border-bottom: 1px solid var(--pe-color-gray-200) !important;
//       }
//       #UpcartPopup  .upcart-internal-component-product-tile__image-wrapper {
//         border-radius: 10px !important;
//         overflow: hidden !important;
//       }
//       #UpcartPopup .upcart-internal-component-product-tile__image {
//         width: 100% !important;
//         height: 100% !important;
//         object-fit: cover !important;
//       }
//       #UpcartPopup .upcart-internal-component-product-tile__variant, #UpcartPopup .upcart-internal-component-product-tile__properties {
//         opacity: 1 !important;
//         font-size: 14px !important;
//         line-height: 1.35 !important;
//       }
//       #UpcartPopup .upcart-internal-cart-items__key-value-pair{
//         color: var(--pe-color-gray-700) !important;
//       }
//       #UpcartPopup .upcart-internal-component-product-tile__product-pricing{
//           margin-block: 10px !important;
//       }
     
//       #UpcartPopup .upcart-internal-component-product-tile__remove-button svg{
//         fill: var(--pe-color-electric-blue) !important;
//       }
//       #UpcartPopup .upcart-internal-component-product-tile__quantity-selector svg {
//         width: 20px !important;
//         height: 20px !important;
//       }
//       #UpcartPopup .upcart-internal-component-product-tile__quantity-selector {
//         height: 37px !important;
//         border-radius: 30px !important;
//         border-color: var(--pe-color-gray-100) !important;
//       }
//        #UpcartPopup .upcart-internal-component-product-tile__quantity-selector input {
//         background: transparent !important;
//       }
//        #UpcartPopup .upcart-internal-component-product-tile__quantity-plus,
//        #UpcartPopup .upcart-internal-component-product-tile__quantity-minus{
//         border-color: transparent !important;
//         width: 37px !important;
//       }
//       #UpcartPopup .upcart-internal-upsell {
//         padding: 30px 0 20px !important;
//         margin: 0 !important;
//       }
//       #UpcartPopup .upcart-internal-style__title-large {
//         font-family: var(--pe-font-family-heading) !important;
//         font-weight: 300 !important;
//         letter-spacing: -0.01em !important;
//         padding: 0 !important;
//         text-align: left !important;
//         font-size: 18px !important;
//         text-transform: capitalize !important;
//         margin-bottom: 20px !important;
//         color: var(--pe-color-black) !important;
//       }
//       #UpcartPopup .upcart-internal-upsell__vertical-layout-wrapper {
//         padding: 0 !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile {
//         padding: 0 ! important;
//         border: 1px solid var(--pe-color-light-gray) !important;
//          background: var(--pe-color-light-gray) !important;
//         border-radius: 10px !important;
//         align-items: stretch !important;
//         overflow: hidden !important;
//         transition: all 0.20s ease-in-out !important;

//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile:hover {
//         border-color: var(--pe-color-neon-green) !important;
//          background: transparent !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile > a{
//           width: 90px !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile__image-container {
//         margin: 0 !important;
//         width: 100% !important;
//         height: 100% !important;
//         border-radius: 0 !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile__image {
//         object-fit: cover !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile__info {
//         padding: 15px !important;
//       }
//       #UpcartPopup .upcart-internal-discount-code__form button,
//       #UpcartPopup .upcart-internal-component-upsell-tile__variant-row button,
//       #UpcartPopup .styles_CustomButton__ a {
//         text-transform: uppercase !important;
//         font-size: 14px !important;
//         font-weight: 500 !important;
//         letter-spacing: 0.05em !important;
//         color: var(--pe-color-black) !important;
//         border: 1px solid transparent !important;
//         transition: all 0.15s ease-in-out !important;
//       }
//       #UpcartPopup .upcart-internal-component-upsell-tile__variant-row button:hover,
//       #UpcartPopup .styles_CustomButton__ a:hover{
//         border-color: var(--pe-color-black) !important;
//       }
//       #UpcartPopup .upcart-internal-discount-code__form button{
//         background: transparent !important;
//         border: 1px solid var(--pe-color-black) !important;
//       }
//       #UpcartPopup .upcart-internal-discount-code__form button:hover,
//       #UpcartPopup .upcart-internal-discount-code__form button:focus{
//         background: var(--pe-color-neon-green) !important;
//         border-color: var(--pe-color-neon-green) !important;
//         color: var(--pe-color-black) !important;
//       }
//        #UpcartPopup .upcart-internal-discount-code {
//           margin-bottom: 0 !important;
//         }
//       #UpcartPopup .upcart-internal-component-upsell-tile__variant-row button,
//        #UpcartPopup .styles_CustomButton__ a {
//         background: var(--pe-color-neon-green) !important;
//       }
//        #UpcartPopup .styles_Footer__{
//         padding: 20px !important;
//         background: var(--pe-color-light-gray) !important;
//         border: none !important;
//       }
//        #UpcartPopup .upcart-internal-component__button, #UpcartPopup .upcart-internal-component__button:visited,
//        #UpcartPopup button.UpcartDesignSettings__button, #UpcartPopup input.UpcartDesignSettings__button, 
//        #UpcartPopup .UpcartDesignSettings__button, #UpcartPopup .UpcartDesignSettings__button span, #UpcartPopup .UpcartDesignSettings__button:visited,
//        #UpcartPopup .UpcartDesignSettings__button:visited,
//        #UpcartPopup .upcart-internal-discount-code__input-wrapper,
//        #UpcartPopup .upcart-internal-component-upsell-tile__variant-row select {
//           border-radius: 30px !important;
//       }
//        #UpcartPopup  .upcart-internal-component-upsell-tile__variant-row select,
//        #UpcartPopup .upcart-internal-component-product-tile__title-link,
//        #UpcartPopup .upcart-internal-component-product-tile {
//         color: var(--pe-color-black) !important;
//       }
//          #UpcartPopup .upcart-internal-component-product-tile__price-group{
//           gap: 5px !important;
//         }
//        #UpcartPopup .upcart-internal-component-product-tile__price-compare-at {
//         opacity: 1 !important;
//         color: var(--pe-color-gray-700) !important;
//       }
//        #UpcartPopup .upcart-internal-component-product-tile__price {
//         font-weight: 600 !important;
//       }
//        #UpcartPopup .upcart-internal-component-product-tile__savings {
//           color: var(--pe-color-electric-blue) !important;
//           font-weight: 600 !important;
//       }
//         #UpcartPopup  .upcart-internal-discount-code__form input,
//         #UpcartPopup .upcart-internal-discount-code__input-wrapper {
//           background: transparent !important;
//         }
//           #UpcartPopup .upcart-internal-discount-code__input-wrapper {
//             border: none !important;
//           }
//         #UpcartPopup  .upcart-internal-discount-code__form input{
//          border: 1px solid var(--pe-color-gray-200) !important;
//          height: 47px !important;
//          border-radius: 30px !important;
//          padding-inline: 17px !important;
//          transition: all 0.15s ease-in-out !important;
//         }
//         #UpcartPopup  .upcart-internal-discount-code__form input:placeholder{
//           color: var(--pe-color-gray-800) !important;
//         }

//         #UpcartPopup  .upcart-internal-discount-code__form input:focus{
//           border-color: var(--pe-color-electric-blue) !important;
//         }
//        #UpcartPopup .upcart-internal-component-upsell-tile__variant-row select {
//         background-color: transparent !important;
//         appearance: none !important;
//         -webkit-appearance: none !important;
//         -moz-appearance: none !important;
//         padding: 8px 25px 8px 15px !important;
//         font-size: 14px !important;
//         background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'%3E%3Cpath d='M1.16797 4.0835L7.0013 9.91683L12.8346 4.0835' stroke='black' stroke-linejoin='round'/%3E%3C/svg%3E");
//         background-repeat: no-repeat !important;
//         background-position: right 10px center !important;
//         background-size: 12px !important;
//       }
//       #UpcartPopup .UpcartDesignSettings__cartTextColor a {
//         color: var(--pe-color-black) !important;
//         font-weight: 500 !important;
//         line-height: 1.2 !important;
//         font-size: 13px !important;
//         color: var(--pe-color-black) !important;
//         letter-spacing: 0.05em !important;
//         text-transform: uppercase !important;
//         opacity: 1 !important;
//         width: 100% !important;
//         text-align: center !important;
//         padding: 13px  !important;
//         border-radius: 30px !important;
//         border: 1px solid var(--pe-color-black) !important;
//         background: transparent !important;
//         transition: all 0.20s ease-in-out !important;
//       }
//       #UpcartPopup .UpcartDesignSettings__cartTextColor a:hover{
//         background: var(--pe-color-neon-green) !important;
//         border-color: var(--pe-color-neon-green) !important;
//         color: var(--pe-color-black) !important;
//       }
//       @media (min-width: 768px) {
//         .upcart-internal-header span{
//             font-size: var(--pe-h5-font-size) !important;
//         }
//         #UpcartPopup .upcart-internal-header.upcart-public-header {
//           padding: 20px !important;
//         }
//         #UpcartPopup .upcart-internal-style__title-large {
//               font-size: 22px !important;
//         }
//         #UpcartPopup .UpcartDesignSettings__cartTextColor a {
//             font-size: 14px !important;
//             padding: 14px  !important;
//         }
//         .styles_CartPreview__{
//           --upcart-internal-desktop-cart-width: 475px !important;
//         }
//         .styles_CartPreview__right__.styles_active__{
//             margin: 20px;
//             height: calc(100% - 40px);
//             border-radius: 30px;
//         }
//       }
//       @media (max-width: 767px) {
//         .upcart-internal-rewards__message,.upcart-internal-component-product-tile__product-title{
//           font-size: 15px !important;
//         }
//         #UpcartPopup .upcart-internal-component-product-tile__variant, #UpcartPopup .upcart-internal-component-product-tile__properties,
//         .upcart-internal-component-product-tile__price-compare-at, #UpcartPopup .upcart-internal-component-upsell-tile__variant-row select,
//         #UpcartPopup .upcart-internal-discount-code__form button, #UpcartPopup .upcart-internal-component-upsell-tile__variant-row button, #UpcartPopup .styles_CustomButton__ a{
//           font-size: 13px !important;
//         }
//         .upcart-internal-component-product-tile__savings, .upcart-internal-component-product-tile__price,
//         .upcart-internal-component-upsell-tile__title, .upcart-internal-component-upsell-tile__price{
//           font-size: 14px !important;
//         }
//       }
//       // add new css here
//     `;
//     let shadowInterval = setInterval(() => {
//       let shadow = document.querySelector('.shopify-app-block #upCart').shadowRoot;
//       if(shadow) {
//         shadow.appendChild(styleTag);
//         clearInterval(shadowInterval);
//       }
//     }, 2000);
//   }
// }

// typeof customJS !== 'undefined' && new customJS();